import { useState } from "react";
import { Control, Controller } from "react-hook-form";

import { NamedCounter } from "components/NamedCounter/NamedCounter";
import { AccordionParent } from "components/AccordionParent/AccordionParent";
import { Accordion } from "components/Accordion/Accordion";

import { ClientGroupForm } from "../ClientGroupInfo";
import styles from "../styles.module.scss";

type Props = {
  control: Control<ClientGroupForm>;
};

const FIELDS = [
  {
    title: "Начальный % скидки",
    varName: "startpercent",
    symbol: "%",
    titleWidth: 140,
  },
  {
    title: "Шаг скидки",
    varName: "shiftpercent",
    symbol: "",
    titleWidth: 130,
  },
  {
    title: "Период увеличения скидки",
    varName: "shiftpercentsum",
    symbol: "",
    titleWidth: 200,
  },
  {
    title: "Текущий % скидки",
    varName: "discountpercent",
    symbol: "%",
    titleWidth: 140,
  },
  {
    title: "Конечный % скидки",
    varName: "endpercent",
    symbol: "%",
    titleWidth: 130,
  },
  {
    title: "Следующее увеличение скидки",
    varName: "nextdiscountsum",
    symbol: "",
    titleWidth: 200,
  },
];

export const Discounts = ({ control }: Props): JSX.Element => {
  const [discountsCollapse, setDiscountsCollapse] = useState(false);

  return (
    <Accordion
      withIcon={false}
      handleCollapse={() => setDiscountsCollapse((prevState) => !prevState)}
      collapsed={!discountsCollapse}
      iconClassNames="mr-3.5"
      parent={
        <AccordionParent
          name="Скидки"
          collapsed={!discountsCollapse}
          iconClassNames="mr-3.5"
        />
      }
    >
      <div className="ml-3 mt-3">
        <div className="flex flex-wrap mt-2 gap-x-8 gap-y-4 justify-center">
          {FIELDS.map((currentField) => (
            <div key={currentField.title} className="flex ml-5 items-center">
              <Controller
                name={currentField.varName as keyof ClientGroupForm}
                control={control}
                render={({ field }) => (
                  <NamedCounter
                    {...field}
                    title={currentField.title}
                    value={field.value as string}
                    symbol={currentField.symbol}
                    titleWidth={currentField.titleWidth}
                  />
                )}
              />
            </div>
          ))}
        </div>
      </div>
    </Accordion>
  );
};
